"use client";

import { Route, Routes } from "react-router-dom";
import { ForeignNationalsProvider } from "../../features/foreignNationals/context/ForeignNationalsContext";
import { ClientProfilePage } from "../../features/clientProfile/ClientProfilePage";
import { ForeignNationalCreate } from "./ForeignNationalCreate";
import { ForeignNationalsDashboard } from "./ForeignNationalsDashboard";

export const ForeignNationalsRoutes = () => {
  return (
    <ForeignNationalsProvider mode="self">
      <Routes>
        <Route path="/" element={<ForeignNationalsDashboard />} />
        <Route path="/new" element={<ForeignNationalCreate />} />
        <Route path="/:clientId" element={<ClientProfilePage />} />
      </Routes>
    </ForeignNationalsProvider>
  );
};
